<div class="flex flex-col h-full">
  <!-- Menu Header with close button for mobile/tablet -->
  <div class="flex items-center justify-between p-4 md:hidden border-b border-black/10">
    <span class="text-lg font-semibold text-black">Menu</span>
    <button 
      mat-icon-button
      (click)="closeMenu.emit()"
      class="text-black hover:bg-black/10">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  
  <div class="flex-1 overflow-y-auto min-h-0" [style.background-color]="'#f2f5f9'">
    <div class="flex flex-col gap-1 p-1">
      @for (item of navItems(); track item.label) {
        <div class="relative flex w-full min-w-0 flex-col">
          @if (item.items && item.items.length > 0) {
            <!-- Collapsible Group -->
            <mat-expansion-panel 
              [expanded]="isGroupExpanded(item.label)"
              (opened)="setGroupExpanded(item.label, true)"
              (closed)="setGroupExpanded(item.label, false)"
              class="sidebar-expansion-panel">
              <mat-expansion-panel-header class="sidebar-group-header">
                <mat-panel-title class="sidebar-group-label" [class.sidebar-group-active]="isGroupActive(item.label)">
                  <div class="flex items-center gap-2">
                    <mat-icon class="sidebar-group-icon">{{ item.icon }}</mat-icon>
                    <span>{{ item.label }}</span>
                  </div>
                  <mat-icon class="sidebar-chevron" [class.rotate-180]="isGroupExpanded(item.label)">expand_more</mat-icon>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="w-full text-sm bg-white">
                <ul class="flex w-full min-w-0 flex-col gap-1">
                  @for (subItem of item.items; track subItem.route) {
                    <li class="group/menu-item relative">
                      <a
                        [routerLink]="subItem.route"
                        [class.sidebar-menu-button-active]="isSubItemActive(subItem)"
                        class="sidebar-menu-button">
                        <mat-icon class="sidebar-menu-icon">{{ subItem.icon }}</mat-icon>
                        <div class="flex flex-col flex-1 min-w-0">
                          <span class="truncate">{{ subItem.label }}</span>
                          @if (subItem.description) {
                            <span class="text-xs text-gray-600 truncate">{{ subItem.description }}</span>
                          }
                        </div>
                      </a>
                    </li>
                  }
                </ul>
              </div>
            </mat-expansion-panel>
          } @else {
            <!-- Single Menu Item -->
            <div class="w-full text-sm">
              <ul class="flex w-full min-w-0 flex-col gap-1">
                <li class="group/menu-item relative">
                  <a
                    [routerLink]="item.route"
                    [class.sidebar-menu-button-active]="isItemActive(item)"
                    class="sidebar-menu-button">
                    <mat-icon class="sidebar-menu-icon">{{ item.icon }}</mat-icon>
                    <span class="truncate">{{ item.label }}</span>
                  </a>
                </li>
              </ul>
            </div>
          }
        </div>
      }
      
      <!-- User Profile Section - Inside scrollable area, at bottom -->
      @if (userName()) {
        <div class="user-profile-section" [style.background-color]="'#f2f5f9'">
          <div class="user-profile-card cursor-pointer" (click)="toggleUserProfile()">
            <div class="user-avatar">
              {{ getInitials(userName()) }}
            </div>
            <div class="user-info">
              <div class="user-name">{{ userName() }}</div>
              @if (userEmail()) {
                <div class="user-email">{{ userEmail() }}</div>
              }
              <div class="user-role">{{ getRolesDisplayLine(userRoles()) }}</div>
            </div>
            <mat-icon class="user-chevron" [class.rotate-180]="userProfileExpanded()">expand_more</mat-icon>
          </div>
          @if (userProfileExpanded()) {
            <div class="user-menu-items">
              <a
                [routerLink]="['/account/settings']"
                routerLinkActive="user-menu-link-active"
                [routerLinkActiveOptions]="{ exact: true }"
                class="settings-link"
                (click)="closeMenu.emit()">
                <mat-icon>settings</mat-icon>
                <span>User Preferences</span>
              </a>
              <button 
                mat-button
                (click)="logoutClick.emit()"
                class="logout-button">
                <mat-icon>logout</mat-icon>
                <span>Logout</span>
              </button>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
